'use strict';

angular.module('userRequestEditControllers')

.controller('BySystemTypeController', ['$scope', '$q', '$state', 'editAccessRequestService', 'businessSystemService', 'userRequest', 'systemTypes', 'systemType', 'existingSysRoles', 'allowableSysRoles', 'defaultEntitlementSysRoles', 'sameAsEmployee', 'sameAsSysRoles', 'arrayHelpers', function ($scope, $q, $state, editAccessRequestService, businessSystemService, userRequest, systemTypes, systemType, existingSysRoles, allowableSysRoles, defaultEntitlementSysRoles, sameAsEmployee, sameAsSysRoles, arrayHelpers) {

    // Scopping
    $scope.systemType = systemType;

    if (!_.isUndefined(sameAsEmployee)) {
        $scope.sameAsEmployee = sameAsEmployee.data;
    }

    // Get pendings an existings
    var getPendingsAndExistings = function () {

        // Get all same as roles
        var sameAsList = _.filter(sameAsSysRoles, function (sameAs) {
            return sameAs.SystemTypeID === systemType.SystemTypeID;
        });
        $scope.userRequest.sameAsSysRoles = sameAsList;
        $scope.groupsOfSameAs = arrayHelpers.getGroupsOfArrays(
            businessSystemService.systemRole.bySystem($scope.userRequest.sameAsSysRoles), 4);

        // Get all pendings roles
        var pendings = _.filter($scope.userRequest.SystemRolePendings, function (pending) {
            return pending.SystemTypeID === systemType.SystemTypeID;
        });
        if ($scope.ctxSearchSystem.withSearch()) {
            pendings = _.filter(pendings, function (pending) {
                return !_.isUndefined(_.find($scope.ctxSearchSystem.systems, { SystemID: pending.SystemID }));
            });
        }
        $scope.userRequest.pendings = pendings;

        // Merge pendings and existings roles
        var existings = _.filter(existingSysRoles, function (existing) {
            return existing.SystemTypeID === systemType.SystemTypeID;
        });
        if ($scope.ctxSearchSystem.withSearch()) {
            existings = _.filter(existings, function (existing) {
                return !_.isUndefined(_.find($scope.ctxSearchSystem.systems, { SystemID: existing.SystemID }));
            });
        }
        existings = editAccessRequestService.mergePendingsAndExistingsRoles(pendings, existings);
        $scope.userRequest.existings = existings;

        // Get existings
        $scope.groupsOfExistings = arrayHelpers.getGroupsOfArrays(
            businessSystemService.systemRole.bySystem(existings), 4);

        // Get default entitlements
        var defEntitlements = _.chain(defaultEntitlementSysRoles)
                               .filter(function (defEntitlement) {
                                   return defEntitlement.SystemTypeID === systemType.SystemTypeID;
                               })
                               .filter(function (defEntitlement) {
                                   return _.findIndex(sameAsList, { SystemRoleID: defEntitlement.SystemRoleID }) === -1;
                               })
                               .value();
        $scope.userRequest.defEntitlements = defEntitlements;

        // Get other allowables
        var allAllowables = _.filter(allowableSysRoles, function (allowable) {
            return _.findIndex(sameAsList, { SystemRoleID: allowable.SystemRoleID }) === -1;
        });

        // Union allowables and default entitlements
        var allowablesAndEntitlements = _.union(allAllowables, defEntitlements);
        allowablesAndEntitlements = _.chain(allowablesAndEntitlements)
                                     .uniq(function (e) { return e.SystemRoleID; })
                                     .filter(function (e) {
                                         return _.findIndex(existings, { SystemRoleID: e.SystemRoleID }) === -1;
                                     })
                                     .value();

        // Filter with search
        if ($scope.ctxSearchSystem.withSearch()) {
            allowablesAndEntitlements = _.filter(allowablesAndEntitlements, function (sysRole) {
                return !_.isUndefined(_.find($scope.ctxSearchSystem.systems, { SystemID: sysRole.SystemID }));
            });
        }

        // Add pending for allowables and default entitlements
        var otherAllowables = _.chain(allowablesAndEntitlements)
                               .filter(function (allowable) {
                                   if (_.isUndefined(allowable.WithEnoughPrivilege)) return true;
                                   return allowable.WithEnoughPrivilege === true;
                               })
                               .map(function (allowable) {
                                   var pending = _.find(pendings, { SystemRoleID: allowable.SystemRoleID })
                                   if (!_.isUndefined(pending)) {
                                       allowable.ToAdd = pending.ToAdd;
                                       allowable.ToRemove = pending.ToRemove;
                                       allowable.ToKeep = pending.ToKeep;
                                   }
                                   return allowable;
                               })
                               .value();
        $scope.userRequest.otherAllowables = otherAllowables;

        $scope.userRequest.allowablesNotPendings = _.filter($scope.userRequest.otherAllowables, function (allowable) {
            return _.isUndefined(allowable.ToAdd);
        });

        $scope.groupsOfAllowables = arrayHelpers.getGroupsOfArrays(
            businessSystemService.systemRole.bySystem(otherAllowables), 4);

        // Get other pendings
        var otherPendings = _.chain(pendings)
                             .filter(function (pending) {
                                    return !_.find(existings, { 'SystemRoleID': pending.SystemRoleID }) &&
                                           (!_.find(allowableSysRoles, { 'SystemRoleID': pending.SystemRoleID }) || 
                                             _.find(allowableSysRoles, {
                                                 'SystemRoleID': pending.SystemRoleID,
                                                 'WithEnoughPrivilege': false
                                             })) &&
                                           !_.find(defEntitlements, { 'SystemRoleID': pending.SystemRoleID });
                             })
                             .map(function (pending) {
                                 var allowable = _.find(allowableSysRoles, { 'SystemRoleID': pending.SystemRoleID });
                                 if (!_.isUndefined(allowable)) {
                                     pending.WithEnoughPrivilege = allowable.WithEnoughPrivilege;
                                 }
                                 return pending;
                             })
                             .value();
        $scope.groupsOfOtherPendings = arrayHelpers.getGroupsOfArrays(
            businessSystemService.systemRole.bySystem(otherPendings), 4);
    }

    $scope.$watch('ctxSearchSystem.systems', function (newValue, oldValue) {
        getPendingsAndExistings();

        if ($scope.ctxSearchSystem.withSearch()) {
            $scope.searchOthers.term = $scope.ctxSearchSystem.searchTerm;
            $scope.searchOthers.search();
        }
        else {
            $scope.searchOthers.term = undefined;
            $scope.searchOthers.search();
        }
    }, true);

    // Search others
    $scope.searchOthers = {};
    $scope.searchOthers.term = null;

    $scope.searchOthers.search = function () {
        if (_.isUndefined($scope.searchOthers.term) || $scope.searchOthers.term.length <= 1) {
            $scope.searchOthers.groupsOfOthers = null;
            return;
        }

        businessSystemService.searchOthersSystemRolesByRequestAndSystemType(
            userRequest.UserAccessRequestID, systemType.SystemTypeID, $scope.searchOthers.term)
        .then(function (results) {
            results = _.filter(results, function (result) {
                return !_.find($scope.userRequest.defEntitlements, { 'SystemRoleID': result.SystemRoleID });
            });

            $scope.searchOthers.noResults = results.length === 0;

            $scope.searchOthers.groupsOfOthers = arrayHelpers.getGroupsOfArrays(
                businessSystemService.systemRole.bySystem(results), 4);
         });
    }

    // Same As
    $scope.addAllSameAs = function () {

        $q.all(_.map($scope.userRequest.sameAsSysRoles, function(systemRole) {
            return editAccessRequestService.systemRolePendings.preAdd($scope.userRequest.UserAccessRequestID, systemRole.SystemRoleID);
        }))
        .then(function (addedSystemRoles) {
            $state.go($state.current, {}, { reload: true });
        });
    }

    // Allowables
    $scope.addAllAllowables = function () {

        $q.all(_.map($scope.userRequest.allowablesNotPendings, function (systemRole) {
            return editAccessRequestService.systemRolePendings.preAdd($scope.userRequest.UserAccessRequestID, systemRole.SystemRoleID);
        }))
        .then(function (addedSystemRoles) {
            $state.go($state.current, {}, { reload: true });
        });
    }

    // Remove all current permissions
    $scope.removeAllExistings = function () {
        var existingsToRemove = _.filter($scope.userRequest.existings, function (existing) {
            return _.isUndefined(existing.ToAdd);
        });

        $q.all(_.map(existingsToRemove, function (systemRole) {
            return editAccessRequestService.systemRolePendings.preClose($scope.userRequest.UserAccessRequestID, systemRole.SystemRoleID);
        }))
        .then(function (removedSystemRoles) {
            $state.go($state.current, {}, { reload: true });
        });
    }
}]);